/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import "react-tooltip/dist/react-tooltip.css";
import ReactGridLayouts from "../components/shellComponents/ReactGridLayoutComponents/ReactGridLayouts";

import { useAuth0 } from "@auth0/auth0-react";

import Sidebar from "@/components/shellComponents/Sidebar/Sidebar";
import MegaPipe from "../lib/MegaPipe";
import LogIn from "./LogIn";

export default function Home() {
  const [firstLoad, setFirstLoad] = useState<boolean>(false);
  // Feature flags are fetched per-window in <FeatureFlagLoader/> (see _app.tsx / LQC-1724).
  const { isAuthenticated, isLoading } = useAuth0();

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="bg-cubeBase-800 p-3 dark:bg-cubeBaseDark-800">
          Logging In
        </div>
      </div>
    );
  }

  return (
    <main className="z-5 flex h-full flex-col items-center justify-between bg-cubeBase-900 dark:bg-cubeBaseDark-900">
      {isAuthenticated ? (
        <div className="z-10 flex h-full w-full flex-row items-center pt-2 font-mono text-sm ">
          <Sidebar firstLoad={firstLoad} setFirstLoad={setFirstLoad} />
          {/* Previous turnary on first load that was needed to be removed to get analytics to render. */}
          <ReactGridLayouts />
          {!firstLoad && (
            <div className="absolute h-full w-full">
              <div className="flex h-full w-full items-center justify-center">
                <div className="relative left-8 top-8">
                  <div className="loader"></div>
                </div>
              </div>
            </div>
          )}
          {/* {true ? (
            <ReactGridLayouts />
          ) : (
            <div className="flex h-full w-full bg-cubeBase-900 bg-cover dark:bg-cubeBaseDark-900 ">
              <div className="flex h-full w-full items-start justify-center">
                <div
                  className={`mainWidgetBackgroundLoading w-max-full r-2 flex h-[99%] w-[99%] rounded-xl border border-gray-200 bg-cubeBase-800 dark:border-black dark:bg-cubeBaseDark-800`}
                >
                  <div className="flex h-full w-full items-center justify-center">
                    <div className="loader"></div>
                  </div>
                </div>
              </div>
            </div>
          )} */}
          <MegaPipe />
        </div>
      ) : (
        <LogIn />
      )}
    </main>
  );
}
